/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { PopupService } from '../../../core/services/popup.service';
import { ConfigService } from './../../../core/services/config.service';
import { UserProfile } from './../../model/user-profile.model';
import { AppUtilityService } from './../../services/app-utility.service';
import { StaticDataStoreService } from './../../services/static-datastore.service';


/**
 * This LmsSearchPanelComponent is created for search panel
 * for top header and side navigation.
 * @export
 * @class LmsSearchPanelComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-search-panel',
  templateUrl: './lms-search-panel.component.html',
  styleUrls: ['./lms-search-panel.component.scss']
})
export class LmsSearchPanelComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input() type: string;
  @Input() indexOfTab: number;
  @Input() parentName: string;
  mileposts: string[] = [];
  mnemonics: string[] = [];
  filteredResults: string[] = [];
  @Output() autoCompleteNotify = new EventEmitter();
  @Output() searchValueChanged = new EventEmitter();
  firstIn = false;
  @Input() searchText: string;
  managerDeskOption: SelectItem[];
  managerDesk: any;
  userProfile: UserProfile;

  /**
   * Creates an instance of LmsSearchPanelComponent.
   * @memberOf LmsSearchPanelComponent
   */
  constructor(private staticDataStoreService: StaticDataStoreService, private configService: ConfigService,
    private appUtilityService: AppUtilityService, private popupService: PopupService) {
    const configdata = this.configService.getConfigData();
    this.managerDesk = this.staticDataStoreService.getValue('commonopsPicklist');
    this.userProfile = this.staticDataStoreService.getValue('userProfile');

  }

  /**
   * This method invoked when component is load.
   * @memberOf LmsSearchPanelComponent
   */
  ngOnInit() {
    this.init();
    this.searchText = this.searchText ? this.searchText : '';
  }

  /**
   * @memberOf LmsSearchPanelComponent
   */
  ngOnChanges() {
    this.init();
  }

  /**
   * @private
   * @param {*} el
   * @param {string} cls
   * @returns
   *
   * @memberOf LmsSearchPanelComponent
   */
  private findAncestor(el: any, cls: string) {
    const tempElement = el;
    while ((el = el.parentElement) && !el.classList.contains(cls)) { };
    if (el === null && tempElement.classList.contains(cls)) {
      return tempElement;
    }
    return el;
  }
  /**
   * Invoked after view is initialize.
   * @memberOf LmsSearchPanelComponent
   */
  ngAfterViewInit() {
    this.init();
  }

  /**
   * Init method
   * @memberOf LmsSearchPanelComponent
   */
  init() {
    this.managerDesk = this.staticDataStoreService.getValue('commonopsPicklist');
    this.userProfile = this.staticDataStoreService.getValue('userProfile');
    // if (this.type && this.type === 'Outlying-Points') {
    this.managerDeskOption = [];

    if (this.managerDesk && this.managerDesk.masterData) {
      this.managerDeskOption.push({
        label: 'Select Desk',
        value: ''
      });
      for (let i = 0; i < this.managerDesk.masterData.zoneList.length; i++) {
        this.managerDeskOption.push({
          label: this.managerDesk.masterData.zoneList[i].zoneCode + ' ' + this.managerDesk.masterData.zoneList[i].zoneDescription,
          value: this.managerDesk.masterData.zoneList[i].zoneCode
        });

      }
    } else if (this.type && this.type === 'Outlying-Points' && this.userProfile && this.userProfile.userPrefWindowList) {
      let deskValue = '';
      for (let i = 0; i < this.userProfile.userPrefWindowList.length; i++) {
        if (this.userProfile.userPrefWindowList[i].deskName) {
          deskValue = this.userProfile.userPrefWindowList[i].deskName;
          break;
        }
      }
      if (this.configService.getConfigData() && this.configService.getConfigData().deskOptions) {
        for (const deskObj of this.configService.getConfigData().deskOptions.values) {
          if ((deskObj.value && deskObj.value.trim().toUpperCase()) === (deskValue && deskValue.trim().toUpperCase())) {
            this.managerDeskOption.push({
              label: deskObj.label,
              value: deskObj.value
            });
          }
        }
      }
    }
  }

  /**
   * This method invoked when perform suggestive search for
   * terminal mnemonic and milepost.
   * @param {any} event
   * @memberOf LmsSearchPanelComponent
   */
  autoCompleteForTerminal(event) {
    this.filteredResults = this.appUtilityService.autoCompleteForTerminal(event);
  }

  /**
   * This method invoked when value selected from suggestive search.
   * @param {string} value
   * @memberOf LmsSearchPanelComponent
   */
  selectValueFromAutoComplete(value: string) {
    let emitValue = value;
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    this.searchText = emitValue;
    if (this.parentName && this.parentName !== 'sideNav') {
      this.autoCompleteNotify.emit('clicked');
    }
  }

  /**
   * Life cycle hook to clean the states
   * @memberOf LmsSearchPanelComponent
   */
  ngOnDestroy() { }

  /**
   * Method invoked when click on cross icon in search text box
   * @memberOf LmsSearchPanelComponent
   */
  removeSearchText() {
    this.searchText = '';
    this.updateSearchText('');
    let searchTextBox;
    if (this.type && this.type === 'Terminal') {
      searchTextBox = document.getElementById('autoCompleteText' + this.parentName);
    } else if (this.type && (this.type === 'Train' || this.type === 'Locomotive')) {
      searchTextBox = document.getElementById('searchTextBox' + this.parentName);
    }
    if (searchTextBox) {
      searchTextBox.focus();
    }
  }

  /**
   * invoked when search value change.
   * @param {any} event
   * @memberOf LmsSearchPanelComponent
   */
  updateSearchText(event) {
    this.searchValueChanged.emit(event);
  }


  updateSearchTextForOulying(event) {
    setTimeout(() => {
      this.updateSearchText(event.value);
      this.autoCompleteNotify.emit('clicked');
    }, 500);
  }

  setFocusToAddTabBtn(parentName: string, event) {
    if (event !== undefined) {
      event.target.select(); //setSelectionRange(0, this.value.length)
    } 
    if (parentName && parentName === 'sideNav') {
      this.popupService.setSubmitBtnId('navpanelOverlayBtn' + this.type);
    }
  }
}
